export default "__VITE_ASSET__993b5cf6__"